<template>
  <div class="export-print-tools">
    <ExportCSV
      :orderInfo="orderInfo"
      :itemsByCategory="itemsByCategory"
      :totalAmount="totalAmount"
      :totalItemsCount="totalItemsCount"
      :disabled="disabled"
      :fileNamePrefix="fileNamePrefix"
      :buttonText="exportButtonText"
      :headers="customHeaders"
    />
    <PrintPDF
      :orderInfo="orderInfo"
      :itemsByCategory="itemsByCategory"
      :totalAmount="totalAmount"
      :totalItemsCount="totalItemsCount"
      :disabled="disabled"
      :buttonText="printButtonText"
    />
  </div>
</template>

<script>
import ExportCSV from './ExportCSV.vue';
import PrintPDF from './PrintPDF.vue';

export default {
  name: 'ExportPrintTools',
  components: {
    ExportCSV,
    PrintPDF
  },
  props: {
    // 订单信息
    orderInfo: {
      type: Object,
      required: true,
      default: () => ({})
    },
    // 按分类分组的物品列表
    itemsByCategory: {
      type: Object,
      required: true,
      default: () => ({})
    },
    // 总金额
    totalAmount: {
      type: Number,
      default: 0
    },
    // 总物品数量
    totalItemsCount: {
      type: Number,
      default: 0
    },
    // 是否禁用所有按钮
    disabled: {
      type: Boolean,
      default: false
    },
    // 文件名前缀
    fileNamePrefix: {
      type: String,
      default: '设备清单'
    },
    // 导出按钮文本
    exportButtonText: {
      type: String,
      default: '导出清单'
    },
    // 打印按钮文本
    printButtonText: {
      type: String,
      default: '打印PDF'
    },
    // 自定义标题行
    customHeaders: {
      type: Array,
      default: () => ['序号', '分类', '设备名称', '规格', '单价(元/天)', '数量', '天数', '小计(元)']
    }
  }
};
</script>

<style scoped>
.export-print-tools {
  display: flex;
  gap: 10px;
  margin: 10px 0 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ExportPrintTools.vue